import { createRouter, createWebHistory } from 'vue-router';
import HomePage from './components/HomePage.vue';
import CVPage from './components/CVPage.vue';
import ContactPage from './components/ContactPage.vue';

const routes = [
    { path: '/', name: 'home', component: HomePage },
    { path: '/accomplishments', name: 'cv', component: CVPage },
    { path: '/contact', name: 'contact', component: ContactPage },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;